import { TRIGGER_MANAGED_EXPORT_RIGHT_SIDE_UPDATE, STOP_MANAGED_EXPORT_RIGHT_SIDE_UPDATE } from './actionTypes';

function triggerUpdate() {
  return {
    type: TRIGGER_MANAGED_EXPORT_RIGHT_SIDE_UPDATE    
  }
}

function stopUpdate() {
  return {
    type: STOP_MANAGED_EXPORT_RIGHT_SIDE_UPDATE
  }
}

export {
  triggerUpdate,
  stopUpdate
}